import React, { useState, useEffect } from "react";
import { Container, Nav, Tab, Card, Navbar, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

import {
  Speedometer,
  People,
  BoxArrowRight,
  Gear,
  PersonBadge
} from "react-bootstrap-icons";

// Componente de Layout
function AdminGeralLayout({ children, activeKeyProp }) {
  const navigate = useNavigate();
  const [activeKey, setActiveKey] = useState(activeKeyProp || "dashboard");
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(true);

  // Cores fixas para o Admin Geral (verde)
  const primaryColor = "#898989";
  const secondaryColor = "#192435ff";
  const bgColor = "#f8f9fa";
  const textColor = "#333";
  const sidebarColor = "#ffffff";
  const btnTextColor = "#ffffff";

  // Usuário logado
  useEffect(() => {
    const storedUser = Cookies.get("usuario");
    if (!storedUser) {
      navigate("/login-admin-geral");
      return;
    }

    const user = JSON.parse(storedUser);
    if (user.role !== "AdministradorGeral") {
        navigate("/login-admin-geral");
        return;
    }
    setUsuario(user);
    setLoading(false);
  }, [navigate]);

  const handleLogout = () => {
    Cookies.remove("authToken");
    Cookies.remove("usuario");
    navigate("/login-admin-geral");
  };

  // Estilos dinâmicos
  const styles = {
    sidebar: {
      backgroundColor: sidebarColor,
      color: textColor,
      minHeight: "100vh",
      paddingTop: "20px",
      boxShadow: "2px 0 5px rgba(0,0,0,0.1)"
    },
    navLink: {
      color: textColor,
      padding: "10px 15px",
      borderRadius: "8px",
      margin: "5px 0",
      transition: "background-color 0.3s, color 0.3s",
      display: "flex",
      alignItems: "center"
    },
   navLinkActive: {
      backgroundColor: primaryColor,
      color: btnTextColor, 
      fontWeight: "bold",
      boxShadow: `0 2px 4px ${primaryColor}55`,
      border: `1px solid ${primaryColor}`
    },
    contentArea: {
      backgroundColor: bgColor,
      minHeight: "100vh",
      padding: "30px",
      color: textColor
    },
    header: {
      marginBottom: "30px",
      borderBottom: `1px solid ${primaryColor}`,
      paddingBottom: "15px"
    }
  };

  const navItems = [
    { key: "dashboard", title: "Dashboard", icon: <Speedometer size={22} />, path: "/admin-geral/dashboard" },
    { key: "clientes-master", title: "Clientes Master", icon: <People size={22} />, path: "/admin-geral/clientes-master" },
    { key: "configuracoes", title: "Configurações", icon: <Gear size={22} />, path: "/admin-geral/configuracoes" }
  ];

  const handleNavigation = (itemKey, path) => {
    setActiveKey(itemKey);
    navigate(path);
  };

  if (loading) {
    return (
      <div
        style={{
          background: bgColor,
          color: textColor,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <>
      <div className="d-flex" style={{ minHeight: "100vh" }}>
        
        {/* SIDEBAR */}
        <div style={styles.sidebar} className="col-lg-2 col-md-3 d-none d-md-block">
          <h4 className="text-center mb-4" style={{ color: primaryColor }}>
            Admin Geral
          </h4>

          <p className="text-center text-muted small">
            Bem-vindo, {usuario?.nome}!
          </p>

          <Nav variant="pills" className="flex-column px-3">
            {navItems.map(item => (
              <Nav.Item key={item.key}>
                <Nav.Link
                  eventKey={item.key}
                  onClick={() => handleNavigation(item.key, item.path)}
                  style={
                    activeKey === item.key
                      ? styles.navLinkActive
                      : styles.navLink
                  }
                  className="d-flex align-items-center"
                >
                  <span className="me-2">{item.icon}</span>
                  {item.title}
                </Nav.Link>
              </Nav.Item>
            ))}

            <Nav.Item className="mt-4">
              <Nav.Link
                onClick={handleLogout}
                style={{ ...styles.navLink, color: "#dc3545" }}
              >
                <BoxArrowRight className="me-2" size={18} /> Sair
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </div>

        {/* CONTEÚDO */}
        <div className="col-lg-10 col-md-9 col-12" style={styles.contentArea}>
          {/* Navbar para mobile */}
          <Navbar
            expand="md"
            variant="dark"
            style={{ backgroundColor: primaryColor }}
            className="d-md-none mb-3 rounded"
          >
            <Container fluid>
              <Navbar.Brand style={{ color: btnTextColor }}>
                Admin Geral
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />

              <Navbar.Collapse id="basic-navbar-nav">
                <Nav>
                  {navItems.map(item => (
                    <Nav.Link
                      key={item.key}
                      onClick={() => handleNavigation(item.key, item.path)}
                      style={
                        activeKey === item.key
                          ? styles.navLinkActive
                          : styles.navLink
                      }
                    >
                      {item.icon} {item.title}
                    </Nav.Link>
                  ))}

                  <Nav.Link onClick={handleLogout} style={{ ...styles.navLink, color: "#dc3545" }}>
                    <BoxArrowRight className="me-2" size={18} /> Sair
                  </Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>

          {/* Conteúdo da página */}
          {children}
        </div>
      </div>
    </>
  );
}

export default AdminGeralLayout;
